import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCheck, faCopy } from "@fortawesome/free-solid-svg-icons";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  background-color: #f5f5f5;
  padding: 16px;
  box-sizing: border-box;
`;

const Card = styled.div`
  width: 100%;
  max-width: 460px;
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: white;
  box-sizing: border-box;
`;

const Title = styled.h3`
  text-align: center;
  margin: 0 0 4px;
  font-size: 20px;
`;

const CheckIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, #28a745, #20c997);
  box-shadow: 0 4px 16px rgba(40, 167, 69, 0.35);
  margin: 12px auto 16px;
`;

const SubText = styled.p`
  text-align: center;
  color: #666;
  font-size: 14px;
  margin: 0 0 16px;
`;

const CodeBox = styled.div`
  background: #f0f4ff;
  border: 2px dashed #667eea;
  border-radius: 8px;
  padding: 16px;
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 2px;
  color: #333;
  text-align: center;
  word-break: break-all;
  overflow-wrap: break-word;
  box-sizing: border-box;
`;

const CopyBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px;
  margin: 0 0 12px;
  border: 2px solid #667eea;
  border-radius: 8px;
  background: transparent;
  color: #667eea;
  font-size: 14px;
  font-weight: bold;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #667eea;
    color: #fff;
  }
`;

const Warning = styled.div`
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 12px;
  margin: 0 0 16px;
  font-size: 12px;
  color: #856404;
  line-height: 1.6;
  box-sizing: border-box;
`;

const NextBtn = styled.button`
  display: block;
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  background: #282c34;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    opacity: 0.9;
  }
`;

const ClosingText = styled.p`
  text-align: center;
  color: #888;
  font-size: 13px;
  margin-top: 16px;
  line-height: 1.6;
`;

function ForgotPasswordComplete() {
  const location = useLocation();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const recoveryCode = location.state?.recoveryCode || "";

  const handleCopy = () => {
    if (!recoveryCode) return;
    navigator.clipboard.writeText(recoveryCode).then(() => {
      setCopied(true);
      toast.success("コピーしました！");
      setTimeout(() => setCopied(false), 3000);
    }).catch(() => {
      toast.error("コピーに失敗しました。手動でコピーしてください。");
    });
  };

  return (
    <Container>
      <Card>
        <CheckIconWrap>
          <FontAwesomeIcon icon={faCircleCheck} color="#fff" size="2x" />
        </CheckIconWrap>
        <Title>パスワード変更完了</Title>
        <SubText>新しいリカバリーキーが発行されました</SubText>

        <CodeBox>
          {recoveryCode || "キーの取得に失敗しました"}
        </CodeBox>

        <CopyBtn onClick={handleCopy}>
          <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
          {copied ? "コピー済み" : "キーをコピーする"}
        </CopyBtn>

        <Warning>
          このキーは今回しか表示されません。<br />
          再度パスワードを忘れた場合に必要です。<br />
          スクリーンショットやメモに保存してください。
        </Warning>

        <NextBtn onClick={() => navigate("/")}>
          トップページへ戻る
        </NextBtn>

        <ClosingText>
          引き続き、無謀な夢への挑戦をお楽しみください。
        </ClosingText>
      </Card>
      <ToastContainer position="top-center" autoClose={3000} />
    </Container>
  );
}

export default ForgotPasswordComplete;
